module.exports = __webpack_public_path__ + "img/vi_identity_card_bg.17cae7cd.png";